import { Injectable } from '@angular/core';
import { IEnquiryDocument } from '@simplyfly/shared';
import { FirestoreService } from '../firestore/firestore.service';

@Injectable({
  providedIn: 'root'
})
export class EnquiryDocumentFirestoreService extends FirestoreService<IEnquiryDocument> {
  protected basePath = 'enquiryDocuments';
}
